import React from 'react'
import useTrans from '@hooks/useTrans'
import { FormError, Tooltip } from '@components/atoms'
import styles from './FormToggle.module.sass'
import { Info } from '@components/icons'

interface Props {
  id: string
  label?: string
  name?: string
  value?: string | number | readonly string[]
  className?: string
  checked?: boolean
  readOnly?: boolean
  disabled?: boolean
  tooltip?: any
  status?: '' | 'success' | 'error'
  errorMessage?: string
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void
  onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
}

const FormToggle = (props: Props) => {
  const {
    id = '',
    label = '',
    name = '',
    value = '',
    className = '',
    checked = false,
    readOnly = false,
    disabled = false,
    tooltip = undefined,
    status = '',
    errorMessage = '',
    onBlur = () => {},
    onFocus = () => {},
    onChange = () => {},
  } = props

  const classNames = `
    ${styles.root} 
    ${tooltip ? styles[`root--tooltip`] : ''}
    ${disabled ? styles['root--disabled'] : ''}
    ${checked ? styles['root--checked'] : ''}
    ${status ? styles[`root--${status}`] : ''}
    ${className}`

  return (
    <div className={classNames}>
      <label htmlFor={id} className={styles.inputWrap}>
        <input
          checked={checked}
          name={name}
          value={value}
          className={styles.input}
          type="checkbox"
          readOnly={readOnly}
          disabled={disabled}
          onBlur={onBlur}
          onFocus={onFocus}
          onChange={onChange}
          id={id}
        />
        <span className={styles.styledInput}></span>
        <span className={styles.label}>{label}</span>
        {!!tooltip && (
          <Tooltip id={`${id}_tooltip`} label={tooltip} pos={'top'}>
            <span className={styles.tooltip}>
              <Info />
            </span>
          </Tooltip>
        )}
      </label>
      <FormError
        id={`${id}_error`}
        message={errorMessage}
        visible={status === 'error'}
        className={styles.error}
      />
    </div>
  )
}

export default FormToggle
